import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

const sections = document.querySelectorAll(".section-scrollTrigger");

if (sections.length > 0) {
    sections[0].classList.add("visible");
}
sections.forEach((section) => {
    ScrollTrigger.create({
        trigger: section,
        start: "top 70%",
        end: "bottom 0%",
        toggleClass: "visible",
        refreshPriority: 0,
        invalidateOnRefresh: true
    });
});